export default {"src":"/_next/static/media/orders.2c74efa5.svg","height":71,"width":71,"blurWidth":0,"blurHeight":0};